import { AppState } from '../index';

export const isRailOpenSelector = ({ railState }: AppState): boolean => railState?.railOpen || false;
